<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
   <li :class="{...getClass, 'on': isSameUrl}" v-if="target($mq)" @click="menuAction">
    <a>{{name}}</a>
  </li>
</template>

<script>
  export default {
    name: 'MainMenuHeaderItem',
    props: {
      name: String,
      href: String,
      classes: {
        type: String,
        default: ''
      },
      target: {
        type: Function,
        default: () => {
          return true
        }
      },
      showLogin: Boolean
    },
    computed: {
      getClass () {
        const classes = {}
        classes[this.classes] = true
        return classes
      },
      isSameUrl () {
        return this.getLastUrl(window.location.href) === this.getLastUrl(this.href)
      }
    },
    methods: {
      menuAction() {
        let url
        if (this.href.startsWith('/')) {
          this.$router.push(this.href)
        } else {
          const action = this.href.split('/')[0]
          const actionTarget = this.href.split('/')[1]

          switch (action) {
          case 'modal':
            this.$modal.show(actionTarget)
            break
          case 'external_url':
            url = this.href.split('/')
            url.shift()
            url = url.join('/')
            window.open(url)
            break
          case 'logout':
            this.logout()
            break
          }
        }
      },
      getLastUrl(href) {
        const hrefTokenizer = href.split('/')
        const lastUrl = hrefTokenizer[hrefTokenizer.length -1].replace(/\?[A-Za-z0-9&=.]*$/, '')
        return `/${lastUrl}`
      },
      logout () {
        this.$store.dispatch('logout')
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";
  li {
    /*flex-grow: 0;*/
    /*min-width: calc(100% / 6)*/
    margin: 0 2.1rem;

    a {
      cursor: pointer;

      &:hover {
        color: @windows-blue;
        font-weight: bold;
      }
    }

    &:last-child {
      margin-right:0;
    }

    &:first-child {
      margin-left:0;
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    li {
      /*flex-grow: 0;*/
      /*min-width: calc(100% / 6)*/
      margin: 0;
      font-size: 1.2rem;
      background-repeat: no-repeat;
      color: @brown-grey;
      flex: 1;
      height: 100%;
      background-position: center top;

      a {
        display: inline-block;
        vertical-align: bottom;
        line-height: 100%;
        position: relative;
      }
    }

    &.on {
      a {
        color: @windows-blue
      }
    }

    &.main {
      background-image: url('../../assets/images/ex-mobile-home@3x.png');
      background-size: 2.375rem 2.75rem;
      &.on {
        background-image: url('../../assets/images/ex-mobile-home-on@3x.png')
      }
    }
    &.map {
      background-image: url('../../assets/images/ex-mobile-map@3x.png');
      background-size: 1.9rem 2.6rem;
      &.on {
        background-image: url('../../assets/images/ex-mobile-map-on@3x.png')
      }
    }
    &.interest {
      background-image: url('../../assets/images/ex-mobile-heart@3x.png');
      background-size: 2.5rem 2.5rem;
      &.on {
        background-image: url('../../assets/images/ex-mobile-heart-on@3x.png')
      }
    }
    &.more {
      background-image: url('../../assets/images/ex-mobile-more@3x.png');
      background-position: center 15%;
      background-size: 2rem 0.5rem;
    }
  }
</style>

